var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("面板名称")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("面板名称"),
      allowClear: ""
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("菜单")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("菜单"),
      allowClear: ""
    },
    on: {
      change: _vm.menuChange
    },
    model: {
      value: _vm.form.menu,
      callback: function ($$v) {
        _vm.$set(_vm.form, "menu", $$v);
      },
      expression: "form.menu"
    }
  }, _vm._l(_vm.MENULIST, function (item) {
    return _c("a-select-option", {
      key: item.key,
      attrs: {
        value: item.key
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.value)) + " ")]);
  }), 1)], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("面板分类")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("面板分类"),
      allowClear: "",
      disabled: _vm.form.menu == "HOME_PAGE" || !_vm.form.menu ? true : false
    },
    model: {
      value: _vm.form.type,
      callback: function ($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }, _vm._l(_vm.TYPELIST, function (item) {
    return _c("a-select-option", {
      key: item.key,
      attrs: {
        value: item.key
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.value)) + " ")]);
  }), 1)], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("使用角色")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("角色"),
      allowClear: ""
    },
    model: {
      value: _vm.form.role,
      callback: function ($$v) {
        _vm.$set(_vm.form, "role", $$v);
      },
      expression: "form.role"
    }
  }, _vm._l(_vm.ROLELIST, function (item) {
    return _c("a-select-option", {
      key: item.key,
      attrs: {
        value: item.key
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.value)) + " ")]);
  }), 1)], 1), _c("a-form-item", [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.onSearch
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("查询")) + " ")]), _vm.isAuth("home.panelStore") ? _c("a-button", {
    attrs: {
      type: "add",
      icon: "plus"
    },
    on: {
      click: function ($event) {
        return _vm.openAddModal(false);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("新增面板")) + " ")]) : _vm._e()], 1)], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.COLUMNS,
      "data-source": _vm.tableData,
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.tablePageChange
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (_, record, index) {
        return [_vm._v(_vm._s((_vm.pagination.current - 1) * _vm.pagination.pageSize + Number(index + 1)))];
      }
    }, {
      key: "mark",
      fn: function (text) {
        return [_vm._v(_vm._s(_vm.$t(text)))];
      }
    }, {
      key: "menu",
      fn: function (text) {
        return [_vm._v(_vm._s(_vm.$t(text)))];
      }
    }, {
      key: "type",
      fn: function (text) {
        return [_vm._v(_vm._s(_vm.$t(text)))];
      }
    }, {
      key: "role",
      fn: function (text) {
        return [_vm._v(_vm._s(_vm.$t(text)))];
      }
    }, {
      key: "action",
      fn: function (text, record) {
        return [_vm.isAuth("home.panelEdit") ? _c("a-button", {
          attrs: {
            type: "edit"
          },
          on: {
            click: function ($event) {
              return _vm.openAddModal(record.id);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _vm._e(), _vm.isAuth("home.panelDelete") ? _c("a-button", {
          staticClass: "marginL15",
          attrs: {
            type: "danger"
          },
          on: {
            click: function ($event) {
              return _vm.handleDelete(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))]) : _vm._e()];
      }
    }])
  }, _vm._l(_vm.COLUMNS, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _c("add-modal", {
    attrs: {
      visible: _vm.addVisible,
      isEdit: _vm.isEdit
    },
    on: {
      save: _vm.onSearch,
      cancel: function ($event) {
        _vm.addVisible = false;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };